class EventEmitter {
  constructor() {
    this.events = {};
  }
  on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }
  emit(event, ...args) {
    //dinleyiciler çağırılır,istenilen sayıda parametre gönderilir
    if (this.events[event]) {
      this.events[event].forEach((listener) => listener(...args));
    }
  }
  off(event, listener) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter((l) => l !== listener);
    }
  }
}

const eventEmitter = new EventEmitter();
export default eventEmitter;

//hata yakalandığında olay iletilir,(app.jsx) dinlenir
